import { observer } from 'mobx-react';
import { FC, ReactElement, useCallback, useMemo } from 'react';
import manageFAQStore from '../../store/manageFAQStore';
import { BUTTON_TITLE, DEBOUNCE_TIME, STATUS_FILTER } from '~/constants/main';
import { SCREENS } from '~/constants/screens';
import { localeStore } from '~/mobx/localesStore';
import { history } from '~/services/history';
import { TBooleanInNumber } from '~/types/main';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import { SearchInput } from '~/view/components/Controls/Inputs';
import Picker from '~/view/components/Controls/Pickers/Picker/Picker';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import './style.scss';

const ManageFAQListHeader: FC = observer((): ReactElement => {
  const onSearch = useCallback((search: string | undefined) => manageFAQStore.setFilters({ search }), []);

  const selectStatus = useCallback((options: IPickerOption[]) => {
    const statusValue: TBooleanInNumber | undefined = options[0]?.value;
    manageFAQStore.setFilters({ status: statusValue });
  }, []);

  const createFAQ = () => {
    history.push(SCREENS.SETTINGS_WEBSITE_MANAGE_FAQ_CREATE());
  };

  const statuses = useMemo((): IPickerOption[] => {
    return [
      { label: localeStore.t(STATUS_FILTER.ACTIVE), value: 1 },
      { label: localeStore.t(STATUS_FILTER.INACTIVE), value: 0 },
    ];
  }, []);

  const selectedStatus = useMemo((): IPickerOption[] => {
    const statusOption: IPickerOption | undefined = statuses.find((option) => manageFAQStore.filters.status === option.value);
    return statusOption ? [statusOption] : [];
  }, [manageFAQStore.filters.status]);

  return (
    <div className="d-flex flex-row justify-content-between mr-4">
      <div className="d-flex flex-row justify-content-start gap-10">
        <SearchInput
          value={manageFAQStore.filters.search}
          onChangeValue={onSearch}
          loading={manageFAQStore.isLoading}
          debounceDelay={DEBOUNCE_TIME.MEDIUM}
          resetIcon
          contentClassName="manage-faq-list-header__search"
        />
        <Picker
          options={statuses}
          selectedOptions={selectedStatus}
          onSelect={selectStatus}
          placeholder={localeStore.t('select_status')}
          className="manage-faq-list-header__status_select"
        />
      </div>

      <Button title={localeStore.t(BUTTON_TITLE.CREATE)} onClick={createFAQ} loading={manageFAQStore.isLoading} />
    </div>
  );
});

export default ManageFAQListHeader;
